import { PropsWithChildren } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ErrorBoundary } from "react-error-boundary";

import { ToastProvider, Toaster } from "@breakingthelines/design-system";

import { SessionBootstrap } from "@/features/auth/components/session-bootstrap";
import { queryClient } from "./query-client";

function GlobalErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <div style={{ padding: "2rem", maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>{error.message}</p>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary
      FallbackComponent={GlobalErrorFallback}
      onReset={() => queryClient.invalidateQueries({ refetchType: "active" })}
    >
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <SessionBootstrap />
          {children}
          <Toaster position="top-right" />
          {import.meta.env.DEV ? (
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
          ) : null}
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
